export const constants = {
  api: {
    crud: '/api/mrrReportRoutes',
  },
  navigate: {
    list: '/common/mrrReport/list',
    view: '/common/mrrReport/view',
  },
  moduleName: ' Material Receipt Report',
  btnLabel: 'New Report',
};

const style1 = {
  backgroundColor: '#4F81BD',
  color: '#fff',
  minWidth: '150px',
};
const style2 = {
  backgroundColor: '#c92a2a',
  color: '#fff',
  minWidth: '150px',
};

export const HeaderStandard = [
  [
    { text: 'S.No.', style: style1 },
    { text: 'Description of Goods', style: style1 },
    { text: 'Part No.', style: style1 },
    { text: 'No Of Pkt/ Pcs', style: style1 },
    { text: 'UOM ', style: style1 },
    { text: 'Total Qty', style: style1 },
    { text: 'Ok qty', style: style1 },
    { text: 'rejected qty', style: style1 },
    { text: 'Location', style: style1 },
    { text: 'Status', style: style1 },
    { text: 'Delete', style: style2 },
  ],
];
